import { render } from "./ChatInputv2.vue?vue&type=template&id=642e1645&scoped=true"
import script from "./ChatInputv2.vue?vue&type=script&lang=js"
export * from "./ChatInputv2.vue?vue&type=script&lang=js"

import "./ChatInputv2.vue?vue&type=style&index=0&id=642e1645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642e1645"]])

export default __exports__